import { BaseEntity } from 'entities'
import moment, { Moment } from 'moment'

export abstract class ViewModel<T extends BaseEntity> {
    public object: T

    constructor(object: T) {
        this.object = object
    }

    protected toDate = (strDate?: string): Moment | undefined => {
        if (strDate) {
            return moment(strDate)
        }
    }

    protected toDateText = (strDate?: string): string => {
        if (strDate) {
            return moment(strDate).format('YYYY/MM/DD')
        } else {
            return '-'
        }
    }

    protected toDateTimeText = (strDate?: string): string => {
        if (strDate) {
            return moment(strDate).format('YYYY/MM/DD HH:mm')
        } else {
            return '-'
        }
    }

    public createdAtText = (): string => {
        return this.toDateTimeText(this.object.createdAt)
    }

    public createDate = (): string => {
        return this.toDateText(this.object.createdAt)
    }
    public updateDate = (): string => {
        return this.toDateText(this.object.updatedAt)
    }
}
